import { defineMessages } from 'react-intl';

export const lineItemPriceMessages = defineMessages({
  pricePerEach: {
    defaultMessage: '{price}/ea',
    description: 'Lite item | Price | Price per each',
  },
});
